import { useTranslation } from '@hotjar/translations';
import type { RecordingsData } from '@hotjar/webapp/domains/activation/featured-insights/types';
import { epochDate } from '@hotjar/webapp/lib/time';
import { DetailsDefinition, DetailsLine, DetailsTitle } from '../../shared/styles';
import { RecordingSidebarFlowGuide } from './components/RecordingSidebarFlowGuide';

export const RecordingSidebar = ({ data }: { data: RecordingsData }): JSX.Element => {
  const { t } = useTranslation();
  const sidebarFlow = {
    exitPageUrl: data.exitPageUrl,
    landingPageUrl: data.landingPageUrl,
    pageCount: data.pageCount,
  };

  return (
    <>
      <RecordingSidebarFlowGuide flow={sidebarFlow} />
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.recording.date')}:
        </DetailsTitle>
        <DetailsDefinition>{epochDate(data.createdAt, 'DD MMM YYYY')}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.recording.country')}:
        </DetailsTitle>
        <DetailsDefinition>{data.countryCode}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.recording.device')}:
        </DetailsTitle>
        <DetailsDefinition>{data.device}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.recording.actions')}:
        </DetailsTitle>
        <DetailsDefinition>{data.actionCount}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.recording.duration')}
          :
        </DetailsTitle>
        <DetailsDefinition>
          {`${new Date(data.duration * 1000).toISOString().slice(14, 19)} min`}
        </DetailsDefinition>
      </DetailsLine>
    </>
  );
};
